import { getDay } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import type { Course, CourseWeekDay, ServerConfig } from 'shared-types';

interface Params {
  openingHours: Course['openingHours'];
  timeZone: ServerConfig['timeZone'];
}

const getOpeningHoursStatus = ({ openingHours, timeZone }: Params) => {
  if (!openingHours?.isEnabled) return null;

  const dayValuesByIndex = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
  };

  const now = new Date();
  const currentDateString = formatInTimeZone(now, timeZone, 'yyyy-MM-dd');
  const currentTimeString = formatInTimeZone(now, timeZone, 'HH:mm');
  const currentDayIndex = getDay(new Date(currentDateString));

  let isCurrentlyOpen = false;
  let daysUntilNextOpen = 0;
  let currentOrNextOpenDate = null;
  let currentOrNextStartTime = null;
  let currentOrNextEndTime = null;

  for (let i = currentDayIndex; i < currentDayIndex + 7; i++) {
    let dayIndex = i;
    if (dayIndex > 6) dayIndex = (i - 7) as typeof currentDayIndex;

    const dayValue = dayValuesByIndex[dayIndex] as CourseWeekDay;
    const dayData = openingHours?.weekDays?.[dayValue];

    if (!dayData?.isOpen) continue;

    if (
      dayIndex === currentDayIndex &&
      dayData.startTime < currentTimeString &&
      dayData.endTime > currentTimeString
    ) {
      isCurrentlyOpen = true;
    }

    currentOrNextOpenDate = currentDateString;
    currentOrNextStartTime = dayData.startTime;
    currentOrNextEndTime = dayData.endTime;
    daysUntilNextOpen = i - currentDayIndex;

    if (
      dayIndex === currentDayIndex &&
      !isCurrentlyOpen &&
      currentTimeString > dayData.endTime
    ) {
      continue;
    }

    break;
  }

  return {
    currentOrNextEndTime,
    currentOrNextOpenDate,
    currentOrNextStartTime,
    daysUntilNextOpen,
    isCurrentlyOpen
  };
};

export default getOpeningHoursStatus;
